import React, { useEffect, useState } from 'react'
import styles from './ProductInfo.module.css'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import IconComponent from '../../../IconComponent/IconComponent';
import { IoArrowBack, IoChevronBack, IoChevronForward } from 'react-icons/io5';
import { IoIosArrowBack } from 'react-icons/io';

export type Products = {
    ID: number;
    SubcategoryID: number;
    Name: string;
    MainImage: string;
    ImageList: string;
    mostSold: number;
    SubCategoria: string;
}

export type ProductInfoProps = {
    setNavBackground: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProductInfo = (props: ProductInfoProps) => {
    const navigate = useNavigate();
    const [product, setProduct] = useState<Products>();
    const [images, setImages] = useState<string[]>([]);
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
    const { slug } = useParams<{ slug: string }>();
    const id = slug?.split('-')[0];

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const res = await axios.get("https://sazuli.pt/api/getProduct", { params: { id } });
                const prod = res.data;
                setProduct(prod);

                let imageArray: string[] = [];

                if (prod.MainImage) {
                    imageArray.push(prod.MainImage);
                }

                if (prod.ImageList) {
                    const splitImages = prod.ImageList
                        .split(";")
                        .map((img: string) => img.trim())
                        .filter((img: string) => img !== "");
                    imageArray = [...imageArray, ...splitImages];
                }

                setImages(imageArray);
                setCurrentImageIndex(0); // reset para primeira imagem ao mudar produto
            } catch (err) {
                navigate("/");
                console.error("Data fetch error:", err);
            }
        };
        fetchAll();
    }, [id, navigate]);

    useEffect(() => {
        props.setNavBackground(true);
    }, []);

    const goPrevImage = () => {
        setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const goNextImage = () => {
        setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className={styles.container}>
            <div className={styles.productInfo}>
                <div className={styles.goBack} onClick={() => navigate(-1)}>
                    <span><IconComponent icon={IoIosArrowBack} size={20} /></span>
                    <span>{product?.SubCategoria}</span>
                </div>

                {/* Show current image with arrows */}
                {images.length > 0 && (
                    <div className={styles.imageContainer}>
                        <button onClick={goPrevImage} className={styles.arrowButton} aria-label="Previous Image">
                            <IconComponent icon={IoChevronBack} size={30} />
                        </button>

                        <img
                            src={`https://sazuli.pt/uploads/${images[currentImageIndex]}`}
                            alt={product?.Name}
                            className={styles.productImage}
                        />

                        <button onClick={goNextImage} className={styles.arrowButton} aria-label="Next Image">
                            <IconComponent icon={IoChevronForward} size={30} />
                        </button>
                    </div>
                )}

                {/* Dots indicator */}
                {images.length > 1 && (
                    <div className={styles.productCount}>
                        {images.map((_, index) => (
                            <span
                                key={index}
                                className={`${styles.dot} ${currentImageIndex === index ? styles.activeDot : ''}`}
                                onClick={() => setCurrentImageIndex(index)}
                            ></span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default ProductInfo;
